import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import './index.css';
import Pagamentos from '../../components/Pagamentos';
import { useHistory, useParams } from "react-router-dom";
import InputMask from 'react-input-mask';
import { parse } from 'date-fns';
import { format } from 'date-fns-tz';
import api from '../../services/api_adiantamento';
import { mask, unMask } from 'remask';
import { Alert } from 'reactstrap';
import Modal from 'react-modal';
import BuscaFornecedor from '../../components/BuscarFornecedor'

export default function NovoAdiantamento() {

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [messageSalvar, setMessageSalvar] = useState(null);
    const [messageAddPgto, setMessageAddPgto] = useState(null);
    const [numDoc, setNumDoc] = useState('');
    const [codFornecedor, setCodFornecedor] = useState('');
    const tipoFornecedor = {
        items: [
            { id: 1, text: "FORNECEDOR" },
            { id: 2, text: "PARCEIRO AGRICOLA" },
        ],
        selectItem: 1
    };
    const [observacao, setObservacao] = useState('');
    const [numBanco, setNumBanco] = useState('');
    const [agencia, setAgencia] = useState('');
    const [conta, setConta] = useState('');
    const [tipoConta, setTipoConta] = useState({
        items: [
            { id: 1, text: "C" },
            { id: 2, text: "P" },
        ],
        selectItem: 1
    });
    const [operacao, setOperacao] = useState('');
    const [cpfCnpjFav, setCpfCnpjFav] = useState('');
    const [favorecido, setFavorecido] = useState('');
    const [tipoDesconto, setTipoDesconto] = useState('');
    const [tiposDesconto, setTiposDesconto] = useState([]);
    const [formaPgto, setFormaPgto] = useState('');
    const [formasPgto, setFormasPgto] = useState([]);
    const [dataPgto, setDataPgto] = useState('');
    const [valor, setValor] = useState('');
    const [percentual, setPercentual] = useState(0);
    const [adiantamento, setAdiantamento] = useState({});
    const [previsaoEncerramento, setPrevisaoEncerramento] = useState('');
    const [fornecedor, setfornecedor] = useState({});
    const [atualizaPgto, setAtualizaPgto] = useState(0);
    const [pagamentos, setPagamentos] = useState([]);
    const [pagamento, setPagamento] = useState(null);
    const [renderpgto, setRenderPgto] = useState(false);
    const [salvar, setSalvar] = useState(true);
    const [dadosBancarios, setDadosBancarios] = useState({});
    const [anexo, setAnexo] = useState('');
    const [usuario, setUsuario] = useState({});
    const [logEmpresa, setLogEmpresa] = useState({});

    let history = useHistory();
    let params = useParams();

    useEffect(() => {
        api.get(`/empresa/find`).then(function (response) {
            if (response.data) {
                setLogEmpresa(response.data);
            }
        }).catch(function (error) {
            // handle error
            console.log(error);
        }).then(function () {
            // always executed
        });
    }, [])

    useEffect(() => {
        api.get(`/usuarios/getbytoken`).then(function (response) {
            if (response.data) {
                setUsuario(response.data);
            }
        }).catch(function (error) {
            // handle error
            console.log(error);
        }).then(function () {
            // always executed
        });
    }, [])

    useEffect(() => {
        if (messageSalvar) {
            setTimeout(() => {
                setMessageSalvar(null);
            }, 3000);
        }
    }, [messageSalvar])

    useEffect(() => {
        if (messageAddPgto) {
            setTimeout(() => {
                setMessageAddPgto(null);
            }, 3000);
        }
    }, [messageAddPgto])

    useEffect(() => {
        if (params.id) {
            api.get(`/adiantamento/id/${params.id}`).then(function (response) {
                if (response.data) {
                    const adi = response.data.adiantamento;
                    adi.url = response.data.uri;
                    setNumDoc(adi.num_documento);
                    setCodFornecedor(adi.fornecedor_id);
                    setPrevisaoEncerramento(format(new Date(adi.previsao_encerramento), 'dd/MM/yyyy', { timeZone: 'America/Sao_Paulo' }));
                    setObservacao(adi.observacao);
                    setAdiantamento(adi);
                    setAnexo(response.data.anexo);
                }
            }).catch(function (error) {
                // handle error
                console.log(error);
            }).then(function () {
                // always executed
            });
            setRenderPgto(true);
        }
    }, [params.id]);

    useEffect(() => {
        api.get(`/tipodesconto`).then(function (response) {
            if (response.data) {
                setTiposDesconto(response.data);
            }
        }).catch(function (error) {
            // handle error
            console.log(error);
        }).then(function () {
            // always executed
        });
    }, []);

    useEffect(() => {
        api.get(`/formapgto`).then(function (response) {
            if (response.data) {
                setFormasPgto(response.data);
            }
        }).catch(function (error) {
            // handle error
            console.log(error);
        }).then(function () {
            // always executed
        });
    }, []);

    function onSubmit(event) {
        event.preventDefault();
        history.push('/adiantamento');
    }

    function handleSelecTipoConta(e) {
        const tipos = Object.assign([], tipoConta);
        tipos.selectItem = e.target.value;
        setTipoConta(tipos);
    }

    function renderTiposDesconto() {
        return (
            tiposDesconto.map((tipo) => {
                return (
                    <div className="custom-control custom-radio col-md-4 mb-2">
                        <input type="radio" value={tipo.id} id={"tipo" + tipo.id} name="radiodesconto" className="custom-control-input" onChange={(e) => setTipoDesconto(e.target.value)} checked={tipo.id == adiantamento.adi_tipo_desconto_id ? true : false} />
                        <label className="custom-control-label" htmlFor={"tipo" + tipo.id}>{tipo.descricao}</label>
                    </div>
                )
            })
        )
    }

    function renderPercentual() {
        if (tipoDesconto == 2) {
            return (
                <div className="col-md-12 row">
                    <div className="col-md-4">
                    </div>
                    <div className="col-md-4">
                        <label>Percentual:</label>
                        <input type="text" id="percentual" className="form-control" value={percentual} onChange={(e) => setPercentual(e.target.value)}></input>
                    </div>
                    <div className="col-md-4">
                    </div>
                </div>
            )
        }
    }

    function renderFormaPgtos() {
        return (
            formasPgto.map((forma) => {
                return (
                    <div className="custom-control custom-radio col-md-4 mb-2">
                        <input type="radio" value={forma.id} id={"formas" + forma.id} name="radiopgto" className="custom-control-input" onChange={(e) => setFormaPgto(e.target.value)} />
                        <label className="custom-control-label" htmlFor={"formas" + forma.id}>{forma.descricao}</label>
                    </div>
                )
            })
        )
    }

    function onSalvar(event) {

        event.preventDefault();

        var adiantamentosalvar = {
            num_documento: numDoc,
            fornecedor_id: codFornecedor,
            empresa_id: logEmpresa.id,
            status: 0,
            anexo: anexo.originalname,
            observacao: observacao,
            adi_tipo_desconto_id: tipoDesconto,
            percentual: percentual,
            previsao_encerramento: parse(previsaoEncerramento, 'dd/MM/yyyy', new Date()),
            usuario_id: 1,
            data: new Date(),
        }

        var dadosbancariossalvar = {
            agencia: agencia,
            num_banco: numBanco,
            conta: conta,
            tipo_conta: tipoConta.text,
            operacao: operacao,
            favorecido: favorecido,
            cpf_cnpj: cpfCnpjFav,
            fornecedor_id: codFornecedor,
        }
        
        if (adiantamento && adiantamento.id) {
            adiantamentosalvar.id = adiantamento.id;
            adiantamentosalvar.adi_tipo_desconto_id = adiantamento.adi_tipo_desconto_id
            api.put(`/adiantamento`, adiantamentosalvar).then(function (response) {

                if (response.data) {
                    setAdiantamento(response.data);
                    setRenderPgto(true);
                    setSalvar(false);
                }
            }).catch(function (error) {
                // handle error
                console.log(error);
            }).then(function () {
                // always executed
            });
        } else {
            api.post(`/adiantamento`, adiantamentosalvar).then(function (response) {
                if (response.data) {
                    setAdiantamento(response.data);
                    setRenderPgto(true);
                    setSalvar(false);
                }
            }).catch(function (error) {
                // handle error
                setMessageSalvar('OCORREU UM ERRO AO SALVAR, VERIFIQUE OS DADOS DIGITADOS')
                console.log(error);
            }).then(function () {
                // always executed
            });
        }

        if (dadosBancarios && dadosBancarios.id) {
            dadosbancariossalvar.id = dadosBancarios.id;
            if (agencia !== '' && numBanco !== '' && conta !== '' && operacao !== '' && favorecido !== '' && cpfCnpjFav !== '' && codFornecedor !== '') {
                api.put(`/dadosbancarios`, dadosbancariossalvar).then(function (response) {
                    if (response.data) {

                    }
                }).catch(function (error) {
                    // handle error
                    console.log(error);
                }).then(function () {
                    // always executed
                });
            }
        } else {
            if (agencia !== '' && numBanco !== '' && conta !== '' && operacao !== '' && favorecido !== '' && cpfCnpjFav !== '' && codFornecedor !== '') {
                api.post(`/dadosbancarios`, dadosbancariossalvar).then(function (response) {
                    if (response.data) {

                    }
                }).catch(function (error) {
                    // handle error
                    console.log(error);
                }).then(function () {
                    // always executed
                });
            }

        }
    }

    useEffect(() => {
        if (codFornecedor !== '') {
            api.get(`/fornecedor/id/${codFornecedor}/empresa_id/${logEmpresa.id}/empresa_fornecedor/0`).then(function (response) {
                if (response.data) {
                    setfornecedor(response.data);
                    if (response.data.dados_bancarios.length > 0) {
                        const dadosbanc = response.data.dados_bancarios[0];
                        setNumBanco(dadosbanc.num_banco);
                        setAgencia(dadosbanc.agencia);
                        setConta(dadosbanc.conta);
                        setOperacao(dadosbanc.operacao);
                        setCpfCnpjFav(dadosbanc.cpf_cnpj);
                        setFavorecido(dadosbanc.favorecido);
                        setDadosBancarios(response.data.dados_bancarios);
                    }
                } else {
                    setfornecedor({
                        cpf_cnpj: '',
                        tipo: '',
                        descricao: '',
                    });
                }
            }).catch(function (error) {
                // handle error
                console.log(error);
            }).then(function () {
                // always executed
            });
        }
    }, [codFornecedor]);

    function handleAddPgto(event) {
        event.preventDefault();
        if (pagamento) {
            var pgtosalvar = {
                id: pagamento.id,
                adi_forma_pgtos_id: formaPgto,
                valor: valor.replace(/[^0-9,]*/g, '').replace(',', '.'),
                data: parse(dataPgto, 'dd/MM/yyyy', new Date()),
            }

            api.put(`/pagamento`, pgtosalvar).then(function (response) {
                if (response.data) {
                    setDataPgto('');
                    setValor('');
                    setAtualizaPgto(atualizaPgto + 1);
                }
            }).catch(function (error) {
                // handle error
                console.log(error);
            }).then(function () {
                // always executed
            });

            setPagamento(null);
            return;
        }


        var pgtosalvar = {
            adi_adiantamento_id: adiantamento.id,
            empresa_id: logEmpresa.id,
            status: 0,
            adi_forma_pgtos_id: formaPgto,
            valor: valor.replace(/[^0-9,]*/g, '').replace(',', '.'),
            data: parse(dataPgto, 'dd/MM/yyyy', new Date()),
        }
        api.post(`/pagamento`, pgtosalvar).then(function (response) {
            if (response.data) {
                setDataPgto('');
                setValor('');
                setAtualizaPgto(atualizaPgto + 1);
            }
        }).catch(function (error) {
            setMessageAddPgto('OCORREU UM ERRO AO ADICIONAR PAGAMENTO, VERIFIQUE OS DADOS DIGITADOS')
            console.log(error);
        }).then(function () {
            // always executed
        });
    }

    useEffect(() => {
        if (adiantamento.id) {
            api.get(`/pagamento/adiantamento/${adiantamento.id}`).then(function (response) {
                if (response.data) {
                    setPagamentos(response.data);
                }
            }).catch(function (error) {
                // handle error
                console.log(error);
            }).then(function () {
                // always executed
            });
        }
    }, [atualizaPgto, adiantamento.id]);

    function handleMaskValor(event) {
        event.preventDefault();
        const originalValue = unMask(event.target.value);
        const maskedValue = mask(originalValue, [
            ",9", ",99", "9,99", "99,99", "999,99", "9.999,99", "99.999,99", "999.999,99", "9.999.999,99", "99.999.999,99", "999.999.999,99"
        ]);
        setValor(maskedValue);
    }

    function handleEditPgto(id) {
        var pgtos = Object.assign([], pagamentos.find(itempgto => itempgto.id == id));

        setPagamento(pgtos);

        const originalValue = pgtos.valor.toString().replace(/[^0-9,]*/g, '').replace(',', '.');

        const maskedValue = mask(originalValue, [
            ",9", ",99", "9,99", "99,99", "999,99", "9.999,99", "99.999,99", "999.999,99", "9.999.999,99", "99.999.999,99", "999.999.999,99"
        ]);

        setValor(maskedValue);
        setDataPgto(format(new Date(pgtos.data), 'dd/MM/yyyy', { timeZone: 'America/Sao_Paulo' }));
        setFormaPgto(pgtos.adi_forma_pgtos_id);
    }

    function handleExcluirPgto() {
        setValor('');
        setDataPgto('');
        setPagamento(null);
        setAtualizaPgto(atualizaPgto + 1);
    }

    function renderPgtos() {
        if (renderpgto) {
            return (
                <>
                    <div className="row border shadow p-3 mb-2 bg-white rounded box">
                        <div className="col-md-12">
                            <h4>FORMA DE PAGAMENTO</h4>
                            <div className="row">
                                {renderFormaPgtos()}
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-6">
                                    <label>Data:</label>
                                    <InputMask mask="99/99/9999" id="cpf_cnpj_favorecido" className="form-control" value={dataPgto} onChange={(e) => setDataPgto(e.target.value)} />
                                </div>
                                <div className="col-md-6">
                                    <label>Valor:</label>
                                    <input type="text" id="valor" className="form-control" value={valor} onChange={handleMaskValor} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className=" row box mb-2 block">
                        {
                            messageAddPgto ? (
                                <Alert color="danger">{messageAddPgto}</Alert>
                            ) : null
                        }
                        <input type="submit" value="Adicionar" onClick={handleAddPgto} className="btn btn-primary btn-lg" />
                    </div>
                    <div className="row border shadow p-3 mb-2 bg-white rounded box">
                        <div className="col-md-12">
                            <h2>PAGAMENTOS</h2>
                            <Pagamentos pagamentos={pagamentos} adiantamento={adiantamento} usuario={usuario} onEditar={handleEditPgto} onExcluir={handleExcluirPgto}></Pagamentos>
                        </div>
                    </div>
                </>
            )
        }
    }

    function handleUpload({ target: { files } }) {

        let anexo = new FormData();
        anexo.append('file', files[0])

        api.post('/adiantamento/posts', anexo).then(function (response) {
            // console.log('response', response);
            if (response.data) {
                
                let data = response.data.buffer;
                let buff = new Buffer(data);
                let base64data = buff.toString('base64');
                let arquivo = response.data;
                arquivo.base64 = base64data;
                let url = `data:${arquivo.mimetype};base64,${base64data}`
                arquivo.url = url;
        
                setAnexo(arquivo);
                
            }
        }).catch(function (error) {
            // handle error
            console.log(error);
        }).then(function () {
            // always executed
        });
    }
   

    function renderAnexo() {

        if (anexo) {

            return (
                <a href={anexo.url} target="_blank" download={anexo.originalname} >{anexo.originalname}</a>
            )
        }

    }
    
    function handleCloseModal() {
        setModalIsOpen(false);
    }
    
    function handleSelect(id) {
        setCodFornecedor(id);
        setModalIsOpen(false);
    }

    return (
        <div className="container-lg">
            <Header title="NOVO ADIANTAMENTO" />
            <div className="col-md-12">
                <div className=" col-md-12">
                    <div className=" row border shadow p-3 mb-2 bg-white rounded box">
                        <div className="col-md-3">
                            <label>Previsao Encerramento:</label>
                            <InputMask mask="99/99/9999" id="previsao" className="form-control" value={previsaoEncerramento} onChange={(e) => setPrevisaoEncerramento(e.target.value)} />
                        </div>
                        <div className="col-md-2">
                            <label>Pedido/Contrato:</label>
                            <input type="text" id="num_doc" className="form-control" value={numDoc} onChange={(e) => setNumDoc(e.target.value)}></input>
                        </div>
                        <div className="col-md-7">
                            <input type="file" className="btn btn-info" onChange={handleUpload} />
                            {renderAnexo()}
                        </div>
                        <div className="col-md-2">
                            <label>Fornecedor:</label>
                            <div className="d-flex">
                                <input type="text" id="cod_fornecedor" className="form-control" value={codFornecedor} onChange={(e) => setCodFornecedor(e.target.value)}></input>
                                <button className="btn btn-sm" onClick={() => setModalIsOpen(true)}><span class="lnr lnr-magnifier"></span></button>
                            </div>
                            <Modal isOpen={modalIsOpen} className="">
                                <BuscaFornecedor onFechar={handleCloseModal} onSelecionar={handleSelect}></BuscaFornecedor>
                            </Modal>
                        </div>
                        <div className="col-md-2">
                            <label>CPF/CNPJ:</label>
                            <input type="text" id="cpf_cnpj" className="form-control" value={fornecedor.cpf_cnpj}></input>
                        </div>
                        <div className="col-md-3">
                            <label>Tipo:</label>
                            <select className="col-md-11" value={fornecedor.tipo}>
                                {tipoFornecedor.items.map((item, index) => (
                                    <option key={index} value={item.id}>{item.text}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-5">
                            <label>Nome:</label>
                            <input type="text" id="nome_fornecedor" className="form-control" value={fornecedor.descricao}></input>
                        </div>
                    </div>
                    <div className="row border shadow p-3 mb-2 bg-white rounded box">
                        <h4 className="col-md-12">OBSERVAÇÃO</h4>
                        <textarea
                            id="w3review"
                            name="w3review"
                            rows="4"
                            cols="50"
                            className="col-md-12"
                            placeholder="DIGITE A OBSERVAÇÃO AQUI"
                            value={observacao}
                            onChange={(e) => setObservacao(e.target.value)}>
                        </textarea>
                    </div>
                    <div className="row border shadow p-3 mb-2 bg-white rounded box">
                        <h4 className="col-md-12">DADOS BANCARIOS</h4>
                        <div className="col-md-1">
                            <label>Número:</label>
                            <input type="text" id="num_banco" className="form-control" value={numBanco} onChange={(e) => setNumBanco(e.target.value)}></input>
                        </div>
                        <div className="col-md-1">
                            <label>Agencia:</label>
                            <input type="text" id="agencia" className="form-control" value={agencia} onChange={(e) => setAgencia(e.target.value)}></input>
                        </div>
                        <div className="col-md-1">
                            <label>Conta:</label>
                            <input type="text" id="conta" className="form-control" value={conta} onChange={(e) => setConta(e.target.value)}></input>
                        </div>
                        <div className="col-md-1">
                            <label>Tipo:</label>
                            <select value={tipoConta.selectItem} onChange={handleSelecTipoConta}>
                                {tipoConta.items.map((item, index) => (
                                    <option key={index} value={item.id}>{item.text}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-1 mb-1">
                            <label>Operacao:</label>
                            <input type="text" id="operacao" className="form-control" value={operacao} onChange={(e) => setOperacao(e.target.value)}></input>
                        </div>
                        <div className="col-md-2">
                            <label>CPF/CNPJ:</label>
                            <input type="text" id="cpf_cnpj_favorecido" className="form-control" value={cpfCnpjFav} onChange={(e) => setCpfCnpjFav(e.target.value)}></input>
                        </div>
                        <div className="col-md-5">
                            <label>Favorecido:</label>
                            <input type="text" id="favorecido" className="form-control" value={favorecido} onChange={(e) => setFavorecido(e.target.value)}></input>
                        </div>
                    </div>
                    <div className="row border shadow p-3 mb-2 bg-white rounded box">
                        <h4 className="col-md-12">TIPO DE DESCONTO</h4>
                        {renderTiposDesconto()}
                        {renderPercentual()}
                    </div>
                </div>
                <div className=" row box mb-2 block">
                    {
                        messageSalvar ? (
                            <Alert color="danger">{messageSalvar}</Alert>
                        ) : null
                    }
                    <input type="submit" value="SALVAR" className="btn btn-primary btn-lg" onClick={onSalvar} />
                </div>
                {renderPgtos()}
            </div>
            <div className="box col-md-12">
                <input type="submit" value="CONFIRMAR" className="btn btn-success btn-lg" onClick={onSubmit} />
            </div>
        </div>
    )
}
